import _asyncToGenerator from "C:/GitLab-Runner/builds/VgMjNYji/0/billing/billingmalta/src/frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { DialogService } from '@common/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom, isObservable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/dialog.service";
import * as i2 from "@ngx-translate/core";
import * as i3 from "ngx-toastr";
// export function canDeactivateViewFactory<T extends IHasChanges>(x: T&Function) {
//     return {
//         name: 'CanDeactivate' + x.name,
//         provider: {
//             provide: 'CanDeactivate' + x.name,
//             useFactory: (dialogService: DialogService, translateService: TranslateService, toastrService) => new CanDeactivateView<T>(dialogService, translateService, toastrService),
//             deps: [DialogService, TranslateService, ToastrService]
//         }
//     };
// }
export class CanDeactivateView {
  constructor(dialogService, translateService, toastrService) {
    this.dialogService = dialogService;
    this.translateService = translateService;
    this.toastrService = toastrService;
  }
  canDeactivate(component) {
    var _this = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(function* (resolve, reject) {
        if (!component.hasChanges()) {
          resolve(true);
        } else {
          const value = yield _this.dialogService.changes(_this.translateService.instant('Unsaved changes'), _this.translateService.instant('There are some unsaved changes. Do you want to save them?'));
          if (value === true) {
            let saveResult = component.saveChanges();
            if (isObservable(saveResult)) saveResult = firstValueFrom(saveResult);
            try {
              yield saveResult;
              _this.toastrService.success(_this.translateService.instant('Save successful'));
              resolve(true);
            } catch (error) {
              _this.toastrService.error(_this.translateService.instant('An error occurred while saving changes'));
              resolve(false);
            }
          } else {
            try {
              component.rejectChanges();
            } catch (e) {}
            resolve(true);
          }
        }
      });
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  }
}
CanDeactivateView.ɵfac = function CanDeactivateView_Factory(t) {
  return new (t || CanDeactivateView)(i0.ɵɵinject(i1.DialogService), i0.ɵɵinject(i2.TranslateService), i0.ɵɵinject(i3.ToastrService));
};
CanDeactivateView.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
  token: CanDeactivateView,
  factory: CanDeactivateView.ɵfac
});